import { getTableProviders } from "@utils/aegean_api_handler";

export const GET_TABLE_PROVIDERS_REQUEST = "GET_TABLE_PROVIDERS_REQUEST";
export const GET_TABLE_PROVIDERS_SUCCESS = "GET_TABLE_PROVIDERS_SUCCESS";
export const GET_TABLE_PROVIDERS_ERROR = "GET_TABLE_PROVIDERS_ERROR";

export const fetchTableProviders = () => (dispatch, getState) => {
  const store = getState();

  if (store.table_providers.isFetching || store.table_providers.data) {
    // Request for (somewhat) static data - no need for multiple requests
    return Promise.resolve();
  }

  dispatch({
    type: GET_TABLE_PROVIDERS_REQUEST
  });

  return getTableProviders()
    .then((result) => {
      dispatch({
        type: GET_TABLE_PROVIDERS_SUCCESS,
        data: result
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_TABLE_PROVIDERS_ERROR,
        error
      });
    });
};
